import type { FC } from 'react';
import { TbActivity, TbAlertTriangle, TbEye, TbPencil, TbPlus, TbTrash } from 'react-icons/tb';

import type { AuditLog } from '@/types';

import { normalizeAuditAction } from '../auditLogFilters';

const AuditLogActionIcon: FC<{ log: AuditLog }> = ({ log }) => {
    const iconStyle = { display: 'block' } as const;
    const action = normalizeAuditAction(log.action);

    if (action === 'Access Denied') {
        return <TbAlertTriangle size='1rem' style={iconStyle} />;
    }

    if (action === 'Create') {
        return <TbPlus size='1rem' style={iconStyle} />;
    }

    if (action === 'Read') {
        return <TbEye size='1rem' style={iconStyle} />;
    }

    if (action === 'Update' || action === 'Partial Update') {
        return <TbPencil size='1rem' style={iconStyle} />;
    }

    if (action === 'Delete') {
        return <TbTrash size='1rem' style={iconStyle} />;
    }

    return <TbActivity size='1rem' style={iconStyle} />;
};

export default AuditLogActionIcon;
